import { gql } from '@apollo/client';

export const FACILITY_FRAGMENT = gql`
  fragment facilityValues on Facility {
    id
    name
    city
    country
    type
    level
  }
`;
